import angular from 'angular';
import { RetailerGroupsExistingUserFieldController } from './retailer-groups-existing-user-field-controller';
import retailerGroupsExistingUserFieldComponent from './retailer-groups-existing-user-field-component';
import './retailer-groups-existing-user-field.scss';

export default angular.module('retailerGroupUserField', [])
  .controller('RetailerGroupsExistingUserField', RetailerGroupsExistingUserFieldController)
  .component('retailerGroupsExistingUserField', retailerGroupsExistingUserFieldComponent)
;



// WEBPACK FOOTER //
// ./src/modules/retailer-groups/components/existing-user-field/retailer-groups-existing-user-field-module.js